export default {
    editMode(state){
        return state.editMode;
    },
    home(state){
        return state.home;
    },
    scrolled(state){
        return state.scrolled;
    },
    storeActiveGroup(state){
        return state.storeActiveGroup;
    },
    themeColor(state){
        return state.themeColor;
    },
};
